import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './ReferralModalV2.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'
import { Gift01 } from 'blaze-ui/icons'
import cx from 'classnames'
import { FREE_REFERRAL_TIERS, FREE_REWARD_TIERS } from 'hooks/useAutopilotLimits'

type Props = {
  referrals: number
}

const ReferralCount = ({ count, active }: { count: number; active: boolean }): React.ReactElement => {
  return (
    <div className={cx(Styles.referralCount, { [Styles.inactive]: !active })}>
      <Heading level={4}>{count}</Heading>
      <Text variant="metadata">{pluralize('Referral', count)}</Text>
    </div>
  )
}

const RewardAmount = ({ amount, active }: { amount: number; active: boolean }): React.ReactElement => {
  return (
    <div className={cx(Styles.rewardAmount, { [Styles.inactive]: !active })}>
      <div className={Styles.rewardAmountTop}>
        <Gift01 size={16} color={active ? 'var(--magenta-50)' : 'var(--dark-80)'} />
        <Heading level={4}>{amount}</Heading>
      </div>
      <div className={Styles.postsPerWeek}>
        <Text variant="metadata">Posts/week</Text>
      </div>
      <Text variant="metadata" color="var(--dark-30)">
        per platform
      </Text>
    </div>
  )
}

const ProgressMarker = ({ isActive }: { isActive: boolean }): React.ReactElement => {
  return <div className={cx(Styles.progressMarker, { [Styles.progressMarkerActive]: isActive })} />
}

export const FreeReferralRewards = ({ referrals }: Props): React.ReactElement => {
  const getActiveMarkerIndex = (): number => {
    if (referrals >= FREE_REFERRAL_TIERS[4]) return 4
    if (referrals >= FREE_REFERRAL_TIERS[3]) return 3
    if (referrals >= FREE_REFERRAL_TIERS[2]) return 2
    if (referrals >= FREE_REFERRAL_TIERS[1]) return 1
    return 0
  }

  const activeMarkerIndex = getActiveMarkerIndex()

  return (
    <div className={Styles.freeEarned}>
      <div className={Styles.freeEarnedTop}>
        {FREE_REFERRAL_TIERS.map((count, i) => (
          <ReferralCount key={count} count={count} active={activeMarkerIndex === i} />
        ))}
      </div>
      <div className={Styles.progressLine}>
        {FREE_REFERRAL_TIERS.map((_, index) => (
          <ProgressMarker key={index} isActive={index === activeMarkerIndex} />
        ))}
      </div>
      <div className={Styles.freeEarnedBottom}>
        {FREE_REWARD_TIERS.map((amount, i) => (
          <RewardAmount key={amount} amount={amount} active={activeMarkerIndex === i} />
        ))}
      </div>
    </div>
  )
}
